import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from './languages';

export const useLanguage = (ns) => {
  const { t, i18n } = useTranslation(ns);

  const currentLanguage = i18n.language || DEFAULT_LANGUAGE;
  const currentLanguageCode = currentLanguage.split('-')[0]; // normalize e.g. en-US -> en

  const activeLanguage = SUPPORTED_LANGUAGES.find(
    (lang) => lang.code === currentLanguageCode
  ) || SUPPORTED_LANGUAGES[0];

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('i18nextLng_manual', 'true');
    }
    if (typeof document !== 'undefined') {
      document.documentElement.lang = langCode;
    }
  };

  return {
    t,
    i18n,
    currentLanguage: activeLanguage,
    currentLanguageCode,
    languages: SUPPORTED_LANGUAGES,
    changeLanguage
  };
};

export default useLanguage;
